export default function Footer() {
  return (
    <footer className="relative border-t border-line-1 bg-void overflow-hidden">
      {/* Massive type */}
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-20 pb-8">
        <h2
          data-testid="footer-mega-type"
          className="font-display font-black tracking-[-0.04em] uppercase leading-[0.85] text-[18vw] md:text-[14vw] text-ink-100 select-none"
        >
          Recall<span className="text-cyber">.</span>
          <br />
          Everything<span className="text-amber">_</span>
        </h2>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-5 gap-8 text-xs tracking-[0.2em] uppercase">
          <div>
            <div className="text-ink-500 mb-3">Product</div>
            <ul className="space-y-2 text-ink-300">
              <li><a href="#sdk" className="hover:text-cyber">SDK</a></li>
              <li><a href="#pricing" className="hover:text-cyber">Pricing</a></li>
              <li><a href="/dashboard" className="hover:text-cyber">Dashboard</a></li>
            </ul>
          </div>
          <div>
            <div className="text-ink-500 mb-3">Open source</div>
            <ul className="space-y-2 text-ink-300">
              <li><a href="https://github.com/Nirvana3339/mnemonic-sdks" target="_blank" rel="noreferrer" className="hover:text-cyber">GitHub</a></li>
              <li><a href="#" className="hover:text-cyber">Docs</a></li>
              <li><a href="#" className="hover:text-cyber">Discord</a></li>
            </ul>
          </div>
          <div>
            <div className="text-ink-500 mb-3">Company</div>
            <ul className="space-y-2 text-ink-300">
              <li><a href="#" className="hover:text-cyber">Manifesto</a></li>
              <li><a href="#" className="hover:text-cyber">Blog</a></li>
              <li><a href="#" className="hover:text-cyber">Careers</a></li>
            </ul>
          </div>
          <div className="col-span-2">
            <div className="text-ink-500 mb-3">Subscribe to the dispatch</div>
            <form
              onSubmit={(e) => e.preventDefault()}
              className="flex border border-line-2"
              data-testid="newsletter-form"
            >
              <input
                type="email"
                placeholder="agent@yourlab.dev"
                data-testid="newsletter-input"
                className="flex-1 bg-transparent px-3 py-2 text-xs font-mono text-ink-100 placeholder:text-ink-500 focus:outline-none"
              />
              <button
                data-testid="newsletter-submit"
                className="bg-cyber text-void px-4 text-[11px] font-bold tracking-[0.2em] hover:bg-cyber-deep"
              >
                ↳ subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="mt-12 flex flex-col md:flex-row justify-between items-start md:items-center text-[10px] tracking-[0.3em] uppercase text-ink-500 border-t border-line-1 pt-6">
          <div>© 2026 mnemo labs · all neurons reserved</div>
          <div className="flex items-center gap-2 mt-2 md:mt-0">
            <span className="w-1.5 h-1.5 bg-terminal animate-pulse" /> reflection.engine · operational
          </div>
        </div>
      </div>
    </footer>
  );
}
